import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ObservationTypeListHelperService } from '../../../../_helpers/list-services/observation-type-list-helper.service';
import { DropDownListElement } from '../../../../shared/utility/drop-down-list-element';
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';
import { LearningSectionFlowControlHelperService } from '../../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service';
import { ObservationSection } from '../../../../_models/timeline-models/section-models/observation-section.model';
import { ErrorModalHelperService } from '../../../../_helpers/error-modal-helper/error-modal-helper.service';
import { TimelineSectionStatus } from '../../../../_models/timeline-models/timeline-section-status.enum';
import { SuccessModalHelperService } from '../../../../_helpers/success-modal-helper/success-modal-helper.service';
import { TimelineSectionsService } from '../../../../_services/timeline-sections/timeline-sections.service';

@Component({
    selector: 'observation-section',
    templateUrl: './observation-section.component.html',
    styleUrls: ['./observation-section.component.css'],
    standalone: false
})
export class ObservationSectionComponent extends BaseLearningSectionComponent {

  @Input() timelineSection = new ObservationSection();
  @ViewChild('description', { static: false }) description: ElementRef;
  public observationTypes: DropDownListElement[] = []

  constructor(protected readonly observationTypeListHelperService: ObservationTypeListHelperService,
    protected readonly flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog,
    private errorModalHelper: ErrorModalHelperService,
    private successModalHelper: SuccessModalHelperService,
    private timelineSectionService: TimelineSectionsService,
  ) {
    super(flowHelperService, dialog);
    this.sectionTitle = 'Observation';
    this.observationTypes = observationTypeListHelperService.getObservationTypes();
  }

  //should be called before saves
  validate(): boolean {
    if (this.timelineSection.observationDescription === '' || this.timelineSection.observationDescription === undefined) {
      this.errorModalHelper.show("Please complete all sections before submitting", { isValidationError: true });
      return false;
    } 
    let sectionDate = new Date(this.timelineSection.sectionDate)
    sectionDate.setHours(0, 0, 0, 0);
    return sectionDate >= this.minSectionDate;
  }
 
  public save(dialogRef: MatDialogRef<any>): void {
    if (this.validate()) {
      let oldStatus = this.timelineSection.status;
      this.timelineSection.status = TimelineSectionStatus.Saved;
      this.postMerge(oldStatus);
    }
  }

  public delete(dialogRef: MatDialogRef<any>): void {
    this.timelineSectionService.deleteObservationSection(this.timelineSection).subscribe((response) => {
    });
}
  
  public unlock(dialogRef: MatDialogRef<any>): void {
    if (this.validate()) {
      let oldStatus = this.timelineSection.status;
      this.timelineSection.status = TimelineSectionStatus.Unlock;
      this.postMerge(oldStatus);
    }
  }
  
  public submit(dialogRef: MatDialogRef<any>): void {
    if (this.validate()) {
      let oldStatus = this.timelineSection.status;
      this.timelineSection.status = TimelineSectionStatus.Submitted;
      this.postMerge(oldStatus);
    }
  }
  
  public approve(dialogRef: MatDialogRef<any>): void {
    if (this.validate()) {
      let oldStatus = this.timelineSection.status;
      this.timelineSection.status = TimelineSectionStatus.Approved;
      this.postMerge(oldStatus);
    }
  }
  
  public reject(dialogRef: MatDialogRef<any>): void {
    if (this.validate()) {
      let oldStatus = this.timelineSection.status;
      this.timelineSection.status = TimelineSectionStatus.Rejected;
      this.postMerge(oldStatus);
    }
  }

  private postMerge(oldStatus: TimelineSectionStatus): void {
    this.timelineSectionService.mergeObservationSection(this.placementId, this.students.map(s => s.studentId), this.subject, this.timelineSection).subscribe((response: ObservationSection) => {
      this.timelineSection = response;
      this._sectionStatusUpdated.next(response.status);
      this.successModalHelper.show(this.timelineSection.status + " successfully");
    }, error => {
      console.error(error);
      this.errorModalHelper.show(error.message, error);
      this.timelineSection.status = oldStatus;
    });
  }

}
